<!-- 教育局-学生托管统计 -->
<template>
<div>
    <div class="index" v-show="!detail.show">
        <div class="title">
            <div class="span1">
                <span>{{$route.name}}</span>
            </div>
        </div>
		<div v-if="org_type!='a'"  class="Homeboxtop_nav_tab">
			<span v-for="(item, index) in tabList" :class="['res-tab', { active: item.area_name === tabName }]" :key="index+item.area_name" @click="tabClick(item)">
				{{ item.area_name }}
			</span>
		</div>
        <div class="m-t">
            <el-form :inline="true" :model="queryParams" label-width="70px">
                <el-form-item label="">
                    <el-select v-model="queryParams.semester" clearable placeholder="选择学年学期" class="label">
                        <el-option v-for="item in semesterList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
				<el-form-item label="">
            		<el-date-picker 
				   	v-model="queryParams.time"
				   	type="daterange"
				   	style="width: 240px;"
				   	range-separator="-"
				   	start-placeholder="开始日期"
				   	end-placeholder="结束日期"
				   	:picker-options="pickerOptions">
				   	</el-date-picker>
          		</el-form-item>
				<el-form-item label="">
                     <el-select
						v-model="queryParams.risk"
						clearable
						placeholder="风险等级"
						class="label"
						>
						<el-option
							v-for="item in riskList"
							:key="item.id"
							:label="item.label"
							:value="item.id"
						>
						</el-option>
						</el-select>   
          		</el-form-item>
                <el-form-item label="" style="margin-left:20px">
                    <el-button type="primary" size="small" @click='searchFun()'>搜索</el-button>
                </el-form-item>
            </el-form>

            <div class="table">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="a" label="机构" align="center">
                    </el-table-column>
                    <el-table-column prop="b" v-if="org_type!='a'" label="所属区域" align="center">
                    </el-table-column>
                    <el-table-column prop="c" label="全职人员数" align="center">
                    </el-table-column>
                    <el-table-column prop="d" label="兼职人员数" align="center">
                    </el-table-column>
					<el-table-column prop="e" label="人均在职时间" align="center">
                    </el-table-column>
					<el-table-column prop="f" label="人员风险等级" align="center">
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination background :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total,prev, pager, next,jumper,sizes" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"></el-pagination>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import api from '@/api/wisdomSchool/index.js'
import * as echarts from "echarts";
export default {
    components:{

    },
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 10,
			queryParams: {
				semester: '',
				campus:'',
				grade: '',
				class: '',
				time:'',
				risk:'',
			},
			semesterList: [
				{id:'xq1',label:'2021~2022年度下学期'},
				{id:'xq2',label:'2021~2022年度上学期'},
				{id:'xq3',label:'2020~2021年度下学期'},
				{id:'xq4',label:'2020~2021年度上学期'},
				{id:'xq5',label:'2019~2020年度下学期'},
				{id:'xq6',label:'2019~2020年度上学期'},
			],
			  riskList: [
					{ id: "xq1", label: "高" },
					{ id: "xq2", label: "中" },
					{ id: "xq3", label: "低" },
				],
			tableData: [
				{ a: "智课	",     b: "汉阳区", c: "21", d: "9",    e: "1年2个月" ,f:'低'},
				{ a: "欧美思	", b: "东西湖区", c: "19", d: "14", e: "6个月" ,f:'中'},
				{ a: "第七感官",   b: "硚口区", c: "28", d: "11",   e: "3年" ,f:'中'},
				{ a: "黑色空间",   b: "江夏区", c: "26", d: "10",   e: "2年3个月" ,f:'中'},
				{ a: "小鱼	",     b: "蔡甸区", c: "13", d: "17",   e: "1个月" ,f:'中'},
				{ a: "许先望	", b: "江汉区", c: "25", d: "20",   e: "1年2个月" ,f:'高'},
				{ a: "果力教育",   b: "江岸区", c: "22", d: "10",   e: "6个月" ,f:'中'},
				{ a: "智位科技",   b: "新洲区", c: "26", d: "8",    e: "3年" ,f:'低'},
				{ a: "海鸟信息",   b: "武昌区", c: "24", d: "11",   e: "2年3个月" ,f:'中'},
				{ a: "博客音乐",   b: "洪山区", c: "19", d: "16",   e: "1个月" ,f:'低'},
			],
            detail:{
                info:{},
                show:false,
            },
			semesterArr:JSON.parse(sessionStorage.getItem('semesterList')) || [],
			weekDate:[],
			pickerOptions: {
				disabledDate(time) {
					// return time.getTime() > Date.now();
				},
			},
			tabList:[
				{area_name:'全市'},
				{area_name:'汉阳区'},
				{area_name:'东西湖区'},
				{area_name:'硚口区'},
				{area_name:'江夏区'},
				{area_name:'经济技术开发区'},
				{area_name:'东湖高新区'},
				{area_name:'蔡甸区'},
				{area_name:'江汉区'},
				{area_name:'江岸区'},
				{area_name:'新洲区'},
				{area_name:'武昌区'},
				{area_name:'洪山区'},
				{area_name:'黄陂区'},
				{area_name:'青山区'},
				{area_name:'东湖风景'},
			],
			tabName:'全市',
		}
	},
	watch:{

	},
	computed:{
		// 教育局级别判断	省级:99  市级:1,10  区县级:2,20,4,40
	 org_type(){
			let str = '';
			if(sessionStorage.getItem("user_level") === "99"){
				str = 'p'
			}
			if(["1", "10"].indexOf(sessionStorage.getItem("user_level")) > -1){
				str = 'c'
			}
      if(["2", "20","4", "40"].indexOf(sessionStorage.getItem("user_level")) > -1){
				str = 'a'
			}
			return str;
		},
	},
	created() {
		this.getDataList();
	},
	methods: {
		tabClick(item){
			this.tabName=item.area_name;
		},
		async getDataList() {
			let params = {
				orgId:sessionStorage.getItem('orgId'),
				platformCode:sessionStorage.getItem('platformCode'),
				schoolYearSemester:this.queryParams.semester,
				campusId:this.queryParams.campus,
				classId:this.queryParams.class,
				gradeId:this.queryParams.grade,
				page:this.pageNum,
				limit:this.pageSize,
			}
		},
		searchFun(){
			this.pageNum=1;
			this.getDataList();
		},
		sizeChangeHandle(val) {
			this.pageSize = val
			this.getDataList()
		},
		currentChangeHandle(val) {
			this.pageNum = val
			this.getDataList()
		},
        toDetail(item){
			this.detail.info=item;
            this.detail.show=true;
        },
        toIndex(){
            this.detail.show=false;
        },
	},
	mounted() {
		// this.semesterList=this.semesterArr.map(v=>({label:v.schoolYear+'第'+v.semester+'学期',id:v.schoolYear+'_'+v.semester}))
		let arr=[];
		for (let i = 1; i <= 7; i++) {
			const time = new Date(new Date().setDate(new Date().getDate() + i - 7));
			const year = time.getFullYear();
			const month = `0${time.getMonth() + 1}`.slice(-2);
			const strDate = `0${time.getDate()}`.slice(-2);
			arr.push(`${month}-${strDate}`);
		}
		this.weekDate=arr;
		this.init();
	},
}
</script>
<style lang="less" scoped>
.index {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.title {
		height: 60px;
		line-height: 48px;
		border-bottom: 1px solid #eaeaea;
		margin-bottom: 20px;
		display: flex;
		justify-content: flex-start;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-weight: bold;
			font-size: 20px;
			text-align: left;
			color: #000;
			margin-right: 30px;
		}
	}

	::v-deep .el-form .el-input__inner {
		width: 150px;
		height: 32px;
		border-radius: 3px;
		background: #fff;
		border: 1px solid #ddd;
	}

	::v-deep .el-table__header tr th {
		background: #f7f7f7;
		box-shadow: 0px 1px 0px #eaeaea;
	}

    ::v-deep .el-date-editor .el-range-separator{
        line-height: 22px;
    }

	.pagination {
		text-align: center;
		margin-top: 30px;
	}

	header{
		width: 100%;
		height: 350px;
		display: flex;
		.header-item{
		width: 50%;
		
		.header-item-text{
			font-size: 14px;
			color: #666;
			padding-left: 20px;
			margin-top: 5px;
		}
		}
		#echarts-box1{
		width:80%;
		height:280px;
		}
		#echarts-box2{
			width: 90%;
			height:280px;
		}
	}
  	.header-item-title{
        font-size: 18px;
        color: #333;
        display: flex;
        align-items: center;
        .circle{
          width: 8px;
          height: 8px;
          display: inline-block;
          background: #4991e1;
          border-radius: 50%;
          margin-right: 10px;
        }
  	}
	.Homeboxtop_nav_tab{
		border-bottom: 1px solid #eaeaea;
		span{
			padding-bottom: 10px;
		}
	}
}
</style>
